import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import {CustomerPortalService} from 'src/app/_services/customer-portal.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { AuthenticationService } from 'src/app/auth/authentication.service';
@Component({
  selector: "app-activate-portal",
  standalone: false,
  templateUrl: "./activate-portal.component.html",
  styleUrl: "./activate-portal.component.scss",
})
export class ActivatePortalComponent {
  translate: any;
  data: any;

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private customerPortalServc: CustomerPortalService,
    private modalServc: BsModalService,
    private errorUtil: ErrorUtil,
    private auth: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.getLanguageData();
  }
  getLanguageData() {
    this.languageTranslateService.wordSrc$.subscribe((data) => {
      if (Object.keys(data).length != 0) {
        this.translate = data;
      }
    });
  }

  onActivate() {
    let payload: any = {
      enabled: true,
    };
    this.customerPortalServc
      .updateCustomerPortalActivationFlag(payload)
      .subscribe(
        (res: any) => {
          console.log(res, "res printing in toggle flag api");
          if (res.status == 200) {
            //portalEnabled
            this.errorUtil.setErrorMessage(
              200,
              "Customer Portal has been activated successfully",
              null,
              "success",
              2000,
            );
            //update the profile_info in localStorage here
            let currentProfileInfo: any = JSON.parse(
              this.auth.getProfileInfo(),
            );
            currentProfileInfo["isCustomerPortalEnabled"] =
              res.body.isCustomerPortalEnabled;
            localStorage.setItem(
              "profile_info",
              btoa(JSON.stringify(currentProfileInfo)),
            );
            let reason = {
              status: "portalEnabled",
              ...res.body
            }
            this.modalServc.setDismissReason(JSON.stringify(reason));
            this.modalRef.hide();
          } else {
            //show error
            this.errorUtil.setErrorMessage(
              res.status,
              "Customer Portal Activation failed. Please try again",
              "Customer Portal Activation failed. Please try again",
              "error",
              2000,
            );
          }
        },
        (err: any) => {
          console.log("err printing", err);
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            "error",
            2000,
          );
        },
      );
  }
}
